"use client";

import { Switch } from "@kyan/ui";

import { useOptionType } from "#/store/options/page/optionType";

export const OptionTypeSwitch: React.FC = () => {
  const { optionType, setOptionType } = useOptionType();

  return (
    <Switch
      type="option"
      value={optionType}
      className="lg:hidden"
      onChange={setOptionType}
    />
  );
};
